export const HTTPContentType = {
    JSON: 'application/json',
    Binary: 'application/octet-stream'
};
//# sourceMappingURL=Common.js.map